export default "__VITE_ASSET__58bNI_cb__"